import React from 'react'
import VideoFile from "../images/bg-video.mp4"
import Img1 from "../images/logo-1.png"
import Img2 from "../images/logo-2.png"
import Img3 from "../images/logo-3.png"
import { Link } from 'react-router-dom'
import Img4 from "../images/social-media-1.png"
import Img5 from "../images/social-media-2.png"
import Img6 from "../images/social-media-3.png"
import Img7 from "../images/social-media-4.png"

const Home = () => {
  return (
    <section className="min-h-screen relative flex justify-evenly items-center"
      style={{ perspective: "1200px" }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        data-idm-ignore="true"
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={VideoFile} type="video/mp4" />
      </video>

      <div className="absolute top-0 left-0 w-full h-full object-cover z-[1] bg-[#0000008c]" />

      <Link to={'/menu-one'} className="relative z-10 w-[26%] p-8  rounded-[2vmax] bg-green-500/20 backdrop-blur-xl border  shadow-2xl
      [transform:rotateY(45deg)] hover:[transform:rotateY(0)] hover:bg-green-500/30 flex justify-center items-center min-h-[60vh] border-[1vmax] border-green-700 cursor-pointer animate-shake"  >
        <img src={Img1} alt="" />
      </Link>
      <Link to={'/menu-two'} className="relative z-10 w-[26%] p-8  rounded-[2vmax] bg-[#F25075]/20 backdrop-blur-xl border  shadow-2xl
      flex justify-center items-center hover:mt-[-3vmax] bg-[#F25075]/30  min-h-[55vh] border-[1vmax] border-[#F25075] cursor-pointer">
        <img src={Img2} alt="" />

      </Link>
      <Link to={'/menu-three'} className="relative z-10 w-[26%] p-8 rounded-[2vmax] bg-[#5E37A1]/20 backdrop-blur-xl border  shadow-2xl [transform:rotateY(-45deg)]  hover:[transform:rotateY(0)] hover:bg-[#5E37A1]/30  flex justify-center items-center min-h-[60vh] border-[1vmax] border-[#5E37A1] cursor-pointer">
        <img src={Img3} alt="" />

      </Link>
      <div className="fixed bottom-[1vmax] w-[60%] left-[20%]  z-[100]    p-[0.5vmax] rounded-2xl grid grid-cols-[0.8fr_1.5fr_1.5fr_0.8fr] items-center customBG-14 ">
        <div className="flex justify-start pl-[1vmax]">
          <img src={Img4} alt="" className='w-[90%] object-contain' />
        </div>
        <Link to={`https://www.tiktok.com/@bodegafoodhall?_r=1&_t=ZP-95pyBjrKYiU`} className='py-[0.5vmax]'
        target='_blank' 
        >
          <img src={Img5} alt="" className='w-[70%] object-contain' />
        </Link>
        <Link to={`https://www.instagram.com/bodegafoodhall?igsh=MXQ1czFwcmFwdDA4MQ%3D%3D&utm_source=qr`} 
        target='_blank' 
        >
          <img src={Img6} alt="" className='w-[80%] object-contain' />
        </Link>
        <div className="flex justify-end pr-[1vmax]" >
          <img src={Img7} alt="" className='w-[90%] object-contain' />
        </div>
      </div>


    </section>
  )
}

export default Home
